module.exports = __webpack_public_path__ + "static/media/bonusSpins_25_30.324b520b.png";